import React, { useEffect, useState, useRef } from "react";
import {
  Flex,
  View,
  Heading,
  Text,
  SelectField,
  Button,
} from "@aws-amplify/ui-react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
  Rectangle,
  PieChart,
  Pie,
  Cell,
  LabelList,
} from "recharts";
import { fetchAllData } from "./DataFetcher";
import { config } from "./config"; // 加载配置
import { fetchData_from_patient } from "./DataFetcher";
import { openTime } from "./TimeTable";
const today = config.getUTC8Time();
let todayymd = config.gettodayymd();
console.log("todayymd", todayymd, "today", today);
// 计算指定月份的诊次数
const calculateMonthlyClinicCount = (yearMonth, leaveDays) => {
  const [year, month] = yearMonth.split("-").map(Number);
  // 计算指定月的天数
  let daysInMonth = new Date(year, month, 0).getDate();
  const currentYearMonth = todayymd.substring(0, 7);
  if (yearMonth === currentYearMonth) {
    const today = parseInt(todayymd.split("-")[2]);
    daysInMonth = Math.min(daysInMonth, today - 1);
  }
  let clinicCount = {
    hansheng: 0,
    yoyo: 0,
  };

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month - 1, day);
    const dateString = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;

    // 檢查日期是否在leaveDays中

    const dayOfWeek = config.daysOfWeek[date.getDay()];

    // 檢查漢聲診所

    // 如果當前日期不在請假列表中
    const hanshengClinics = openTime.hansheng[dayOfWeek];
    let offDays = leaveDays.hansheng[dateString] || [];
    let availableClinics = hanshengClinics.filter(
      (clinic) => !offDays.includes(clinic)
    );
    clinicCount.hansheng += availableClinics.length;

    // 檢查yoyo診所
    const yoyoClinics = openTime.yoyo[dayOfWeek];
    offDays = leaveDays.yoyo[dateString] || [];
    availableClinics = yoyoClinics.filter(
      (clinic) => !offDays.includes(clinic)
    );
    clinicCount.yoyo += availableClinics.length;
  }

  return clinicCount;
};

const addClinicCount = async (data) => {
  let leaveDays = await fetchData_from_patient("leave");
  leaveDays = leaveDays[0].data;
  // console.log("leaveDays", leaveDays);
  for (const [clinic, monthYearMap] of Object.entries(data)) {
    for (const [monthYear, monthData] of Object.entries(monthYearMap)) {
      let clinicCount = calculateMonthlyClinicCount(monthYear, leaveDays);
      data[clinic][monthYear].summary.clinicCount = clinicCount[clinic];
    }
  }
  return data;
};

const calculateFees = (data) => {
  for (const [clinic, monthYearMap] of Object.entries(data)) {
    for (const [monthYear, monthData] of Object.entries(monthYearMap)) {
      const summary = monthData.summary;
      // summary.totalClinicFee = 0;
      // summary.totalDoctorFee = 0;
      summary.totalFee = {
        count: 0,
        clinic: 0,
        doctor: 0,
        clinicFee: 0,
        doctorFee: 0,
      };

      for (const [key, count] of Object.entries(summary)) {
        if (config.feeTable[key]) {
          let clinicFee = 0;
          let doctorFee = 0;
          if (key === "totalBloodTestType") {
            for (const [type, typeCount] of Object.entries(count)) {
              clinicFee +=
                typeCount * config.feeTable.totalBloodTestType[type].clinic;
              doctorFee +=
                typeCount * config.feeTable.totalBloodTestType[type].doctor;
            }
          } else {
            clinicFee = count * config.feeTable[key].clinic;
            doctorFee = count * config.feeTable[key].doctor;
          }
          summary[key] = {
            count: count,
            clinic: config.feeTable[key].clinic,
            doctor: config.feeTable[key].doctor,
            clinicFee: clinicFee,
            doctorFee: doctorFee,
          };
          summary.totalFee.clinicFee += clinicFee;
          summary.totalFee.doctorFee += doctorFee;
        } else if (key !== "totalFee") {
          summary[key] = {
            count: count,
            clinic: 0,
            doctor: 0,
            clinicFee: 0,
            doctorFee: 0,
          };
        }
      }
      summary.listlingFee = {
        count: 1,
        clinic: 0,
        doctor: config.feeTable.listlingFee[clinic],
        clinicFee: 0,
        doctorFee: config.feeTable.listlingFee[clinic],
      };
      // 添加挂牌費
      summary.totalFee.doctorFee += config.feeTable.listlingFee[clinic];
    }
  }
  // console.log("data from calculateFees", data);
  return data;
};

function Report({ user }) {
  const sortedDataRef = useRef({});
  const [selectedClinic, setSelectedClinic] = useState("hansheng");
  const [selectedItem, setSelectedItem] = useState("arrived");
  const [data, setData] = useState([]);
  const [advertisementData, setAdvertisementData] = useState({});
  const [total, setTotal] = useState({
    arrived: 0,
    notArrived: 0,
    doctorInfo: 0,
    boneAge: 0,
    daflon: 0,
    daflon4W: 0,
    leuplin12W: 0,
    growthHormone: 0,
    omnitrop: 0,
    bloodTest: 0,
    ultrasoundForPelvis: 0,
  });
  const [months, setMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDataKey, setSelectedDataKey] = useState("arrived");

  const dataKeyOptions = [
    { label: "到達人數", value: "arrived" },
    { label: "未到人數", value: "notArrived" },
    { label: "醫生問診", value: "doctorInfo" },
    { label: "骨齡", value: "boneAge" },
    { label: "達菲林12W", value: "daflon" },
    { label: "達菲林4W", value: "daflon4W" },
    { label: "柳菩林12W", value: "leuplin12W" },
    { label: "生長激素", value: "growthHormone" },
    { label: "歐密拓", value: "omnitrop" },
    { label: "血液檢查", value: "bloodTest" },
    { label: "盆腔超聲", value: "ultrasoundForPelvis" },
    // { label: "門診節數", value: "clinicCount" },
    // { label: "掛牌費", value: "listlingFee" },
    { label: "初診", value: "first" },
    { label: "複診", value: "notFirst" },
    // { label: "血檢", value: "bloodTestType" },
  ];

  useEffect(() => {
    if (
      sortedDataRef.current[selectedClinic] &&
      sortedDataRef.current[selectedClinic][selectedMonth]
    ) {
      setData(sortedDataRef.current[selectedClinic][selectedMonth].data);
      setTotal(sortedDataRef.current[selectedClinic][selectedMonth].summary);
      setMonths(Object.keys(sortedDataRef.current[selectedClinic]));
    }
  }, [selectedClinic, selectedMonth]);

  useEffect(() => {
    async function fetchData() {
      try {
        let allData = JSON.parse(localStorage.getItem("allData"));
        let data = {};
        let adData = {};
        // 如果allData不存在或allData.createTime不等於todayymd
        if (!allData || allData.createTime !== todayymd) {
          let fetchData = await fetchAllData("clinic_patient_db");
          if (fetchData) {
            data = processSampleData(fetchData);
            adData = processADData(fetchData);
            data = await addClinicCount(data);
            data = calculateFees(data);
            allData = {
              createTime: todayymd,
              data: data,
              advertisementData: adData,
            };
            // localStorage.setItem("allData", JSON.stringify(allData));
          }
        } else {
          data = allData.data;
          adData = allData.advertisementData;
        }

        sortedDataRef.current = data;
        setAdvertisementData(adData);

        // 選擇最大的鍵值
        const biggestKey = Object.keys(
          sortedDataRef.current[selectedClinic]
        ).reduce((a, b) => (a > b ? a : b));

        setMonths(Object.keys(sortedDataRef.current[selectedClinic]));
        setSelectedMonth(biggestKey);
        setData(sortedDataRef.current[selectedClinic][biggestKey].data);
        setTotal(sortedDataRef.current[selectedClinic][biggestKey].summary);
      } catch (error) {
        console.error("獲取或處理數據時出錯：", error);
      }
    }

    fetchData();
  }, []);

  if (!user) {
    return <div>請先登入</div>;
  }

  const handaleAdvertisementData = (e) => {
    setSelectedDataKey(e.target.value);
    console.log("selectedDataKey", e.target.value);
  };

  if (!total || total.totalNotArrived === undefined) {
    return <div>Loading...</div>; // 或者返回一个加载指示器
  }
  if (!user) {
    return <div>請先登入</div>;
  }
  if (user?.account === "admin") {
    return (
      // <Flex direction="column" height="100vh" gap="0">

      <Flex flex="1" gap="0" direction="column">
        <View
          flex="1"
          padding="0"
          margin="0"
          backgroundColor="background.secondary"
          style={{
            borderRight: "1px solid",
            borderBottom: "1px solid",
            borderColor: "border.primary",
            // width: "30%",
            // height: "100vh",
            display: "flex",
            flexDirection: "column",
            resize: "horizontal",
            overflow: "auto",
          }}
        >
          {/* 第一部分 */}
          <View style={{ flex: 1 }}>
            <Flex direction="row" gap="1rem" marginBottom="1rem">
              <Button
                onClick={() => setSelectedClinic("hansheng")}
                color={selectedClinic === "hansheng" ? "blue" : "gray"}
                backgroundColor={
                  selectedClinic === "hansheng" ? "lightblue" : "white"
                }
              >
                hangsheng
              </Button>
              <Button
                onClick={() => setSelectedClinic("yoyo")}
                color={selectedClinic === "yoyo" ? "blue" : "gray"}
                backgroundColor={
                  selectedClinic === "yoyo" ? "lightblue" : "white"
                }
              >
                yoyo
              </Button>
              <Text
                style={{
                  color: "grey",
                  textAlign: "right",
                  marginLeft: "auto",
                }}
              >
                資料統計至{todayymd}
              </Text>
            </Flex>
            <SelectField
              label="選擇月份"
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                setData(
                  sortedDataRef.current[selectedClinic][e.target.value].data
                );
                setTotal(
                  sortedDataRef.current[selectedClinic][e.target.value].summary
                );
              }}
              value={selectedMonth}
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </SelectField>

            <table style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th>項目</th>
                  <th>數量</th>
                  <th>單價(診所)</th>
                  <th>單價(醫師)</th>
                  <th>總額(診所)</th>
                  <th>總額(醫師)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>總預約數</td>
                  <td>
                    {total.totalArrived.count + total.totalNotArrived.count}
                  </td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>報到人數</td>
                  <td>{total.totalArrived.count}</td>
                  <td>{total.totalArrived.clinic}</td>
                  <td>{total.totalArrived.doctor}</td>
                  <td>{total.totalArrived.clinicFee}</td>
                  <td>{total.totalArrived.doctorFee}</td>
                </tr>
                <tr>
                  <td>未到人數</td>
                  <td>{total.totalNotArrived.count}</td>
                  <td>{total.totalNotArrived.clinic}</td>
                  <td>{total.totalNotArrived.doctor}</td>
                  <td>{total.totalNotArrived.clinicFee}</td>
                  <td>{total.totalNotArrived.doctorFee}</td>
                </tr>
                <tr>
                  <td>初診人數</td>
                  <td>{total.totalFirst.count}</td>
                  <td>{total.totalFirst.clinic}</td>
                  <td>{total.totalFirst.doctor}</td>
                  <td>{total.totalFirst.clinicFee}</td>
                  <td>{total.totalFirst.doctorFee}</td>
                </tr>
                <tr>
                  <td>初診問診</td>
                  <td>{total.totalFirstDoctorInfo.count}</td>
                  <td>{total.totalFirstDoctorInfo.clinic}</td>
                  <td>{total.totalFirstDoctorInfo.doctor}</td>
                  <td>{total.totalFirstDoctorInfo.clinicFee}</td>
                  <td>{total.totalFirstDoctorInfo.doctorFee}</td>
                </tr>
                <tr>
                  <td>複診人數</td>
                  <td>{total.totalNotFirst.count}</td>
                  <td>{total.totalNotFirst.clinic}</td>
                  <td>{total.totalNotFirst.doctor}</td>
                  <td>{total.totalNotFirst.clinicFee}</td>
                  <td>{total.totalNotFirst.doctorFee}</td>
                </tr>
                <tr>
                  <td>複診問診</td>
                  <td>{total.totalNotFirstDoctorInfo.count}</td>
                  <td>{total.totalNotFirstDoctorInfo.clinic}</td>
                  <td>{total.totalNotFirstDoctorInfo.doctor}</td>
                  <td>{total.totalNotFirstDoctorInfo.clinicFee}</td>
                  <td>{total.totalNotFirstDoctorInfo.doctorFee}</td>
                </tr>
                <tr>
                  <td>骨齡</td>
                  <td>{total.totalBoneAge.count}</td>
                  <td>{total.totalBoneAge.clinic}</td>
                  <td>{total.totalBoneAge.doctor}</td>
                  <td>{total.totalBoneAge.clinicFee}</td>
                  <td>{total.totalBoneAge.doctorFee}</td>
                </tr>
                <tr>
                  <td>達菲林12W</td>
                  <td>{total.totalDaflon.count}</td>
                  <td>{total.totalDaflon.clinic}</td>
                  <td>{total.totalDaflon.doctor}</td>
                  <td>{total.totalDaflon.clinicFee}</td>
                  <td>{total.totalDaflon.doctorFee}</td>
                </tr>
                <tr>
                  <td>達菲林4W</td>
                  <td>{total.totalDaflon4W.count}</td>
                  <td>{total.totalDaflon4W.clinic}</td>
                  <td>{total.totalDaflon4W.doctor}</td>
                  <td>{total.totalDaflon4W.clinicFee}</td>
                  <td>{total.totalDaflon4W.doctorFee}</td>
                </tr>
                <tr>
                  <td>柳菩林12W</td>
                  <td>{total.totalLeuplin12W.count}</td>
                  <td>{total.totalLeuplin12W.clinic}</td>
                  <td>{total.totalLeuplin12W.doctor}</td>
                  <td>{total.totalLeuplin12W.clinicFee}</td>
                  <td>{total.totalLeuplin12W.doctorFee}</td>
                </tr>
                <tr>
                  <td>生長激素</td>
                  <td>{total.totalGrowthHormone.count}</td>
                  <td>{total.totalGrowthHormone.clinic}</td>
                  <td>{total.totalGrowthHormone.doctor}</td>
                  <td>{total.totalGrowthHormone.clinicFee}</td>
                  <td>{total.totalGrowthHormone.doctorFee}</td>
                </tr>
                <tr>
                  <td>歐密拓</td>
                  <td>{total.totalOmnitrop.count}</td>
                  <td>{total.totalOmnitrop.clinic}</td>
                  <td>{total.totalOmnitrop.doctor}</td>
                  <td>{total.totalOmnitrop.clinicFee}</td>
                  <td>{total.totalOmnitrop.doctorFee}</td>
                </tr>
                <tr>
                  <td>血液檢查</td>
                  <td>{total.totalBloodTest.count}</td>
                  <td>-</td>
                  <td>-</td>
                  <td>{total.totalBloodTestType.clinicFee}</td>
                  <td>{total.totalBloodTestType.doctorFee}</td>
                </tr>
                <tr>
                  <td>盆腔超聲</td>
                  <td>{total.totalUltrasoundForPelvis.count}</td>
                  <td>{total.totalUltrasoundForPelvis.clinic}</td>
                  <td>{total.totalUltrasoundForPelvis.doctor}</td>
                  <td>{total.totalUltrasoundForPelvis.clinicFee}</td>
                  <td>{total.totalUltrasoundForPelvis.doctorFee}</td>
                </tr>
                <tr>
                  <td>門診節數</td>
                  <td>{total.clinicCount.count}</td>
                  <td>{total.clinicCount.clinic}</td>
                  <td>{total.clinicCount.doctor}</td>
                  <td>{total.clinicCount.clinicFee}</td>
                  <td>{total.clinicCount.doctorFee}</td>
                </tr>
                <tr>
                  <td>掛牌費</td>
                  <td>{total.listlingFee.count}</td>
                  <td>{total.listlingFee.clinic}</td>
                  <td>{total.listlingFee.doctor}</td>
                  <td>{total.listlingFee.clinicFee}</td>
                  <td>{total.listlingFee.doctorFee}</td>
                </tr>
                <tr>
                  <td style={{ color: "red", fontWeight: "bold" }}>總額</td>
                  <td>{total.totalFee.count}</td>
                  <td>{total.totalFee.clinic}</td>
                  <td>{total.totalFee.doctor}</td>
                  <td style={{ color: "red", fontWeight: "bold" }}>
                    {total.totalFee.clinicFee}
                  </td>
                  <td style={{ color: "red", fontWeight: "bold" }}>
                    {total.totalFee.doctorFee}
                  </td>
                </tr>
              </tbody>
            </table>
          </View>
        </View>
        <View
          flex="1"
          padding="0"
          margin="0"
          backgroundColor="background.secondary"
          style={{
            // width: "70%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <View
            style={{
              flex: 1,
              borderBottom: "1px solid",
              borderColor: "border.primary",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Heading
              level={4}
              style={{ backgroundColor: "yellow", color: "red" }}
            >
              總金額
            </Heading>
            <Flex
              direction={{ base: "column", xl: "row" }}
              alignItems="center"
              justifyContent="center"
            >
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={[
                    {
                      name: "總費用",
                      醫生費用: total.totalFee.doctorFee,
                      診所費用: total.totalFee.clinicFee,
                    },
                  ]}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="醫生費用" fill="#FFA07A">
                    <LabelList dataKey="醫生費用" position="top" />
                  </Bar>
                  <Bar dataKey="診所費用" fill="#82ca9d">
                    <LabelList dataKey="診所費用" position="top" />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>

              <ResponsiveContainer width="100%" height={550}>
                <PieChart>
                  <Pie
                    data={Object.entries(total)
                      .filter(
                        ([key, value]) =>
                          key !== "totalFee" &&
                          value.doctorFee &&
                          value.doctorFee > 0
                      )
                      .map(([key, value]) => ({
                        name: key.toLowerCase().startsWith("total")
                          ? Object.keys(config.EnglishToChinese).find(
                              (k) =>
                                k.toLowerCase() === key.slice(5).toLowerCase()
                            )
                            ? config.EnglishToChinese[
                                Object.keys(config.EnglishToChinese).find(
                                  (k) =>
                                    k.toLowerCase() ===
                                    key.slice(5).toLowerCase()
                                )
                              ]
                            : key
                          : Object.keys(config.EnglishToChinese).find(
                              (k) => k.toLowerCase() === key.toLowerCase()
                            )
                          ? config.EnglishToChinese[
                              Object.keys(config.EnglishToChinese).find(
                                (k) => k.toLowerCase() === key.toLowerCase()
                              )
                            ]
                          : key,
                        value: value.doctorFee,
                        percent: (
                          (value.doctorFee / total.totalFee.doctorFee) *
                          100
                        ).toFixed(2),
                      }))
                      .sort((a, b) => b.percent - a.percent)}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    fill="#8884d8"
                    label={false}
                  >
                    {Object.entries(total)
                      .filter(
                        ([key, value]) =>
                          key !== "totalFee" &&
                          value.doctorFee &&
                          value.doctorFee > 0
                      )
                      .map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            [
                              "red",
                              "blue",
                              "green",
                              "purple",
                              "orange",
                              "pink",
                              "brown",
                              "gray",
                              "cyan",
                            ][index % 9]
                          }
                        />
                      ))}
                  </Pie>
                  <Tooltip />
                  <Legend
                    layout="vertical"
                    align="right"
                    verticalAlign="middle"
                    wrapperStyle={{ width: "35%" }}
                    formatter={(value, entry, index) => {
                      const { payload } = entry;
                      return (
                        <span
                          style={{
                            display: "inline-block",
                            wordBreak: "break-word",
                          }}
                        >
                          {`${payload.name}: ${payload.value} (${payload.percent}%)`}
                        </span>
                      );
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </Flex>
          </View>
          <View
            style={{
              flex: 1,
              borderBottom: "1px solid",
              borderColor: "border.primary",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Heading
              level={4}
              style={{ backgroundColor: "yellow", color: "red" }}
            >
              來源分析
            </Heading>
            <View
              style={{
                top: "50px",
                // width: "20vw",
              }}
            >
              <SelectField
                label="選擇廣告分類項目"
                value={selectedItem}
                onChange={(e) => setSelectedItem(e.target.value)}
              >
                {Object.keys(
                  advertisementData[selectedClinic][selectedMonth]
                ).map((key) => {
                  // console.log("廣告來源:", key);
                  return (
                    <option key={key} value={key}>
                      {key}
                    </option>
                  );
                })}
              </SelectField>
              <Flex>
                <ResponsiveContainer width="100%" height={550}>
                  <PieChart>
                    <Pie
                      data={Object.entries(
                        advertisementData[selectedClinic][selectedMonth][
                          selectedItem
                        ]
                      )
                        .map(([key, value]) => ({
                          name: key,
                          value: value,
                          percent: (() => {
                            const total = Object.values(
                              advertisementData[selectedClinic][selectedMonth][
                                selectedItem
                              ]
                            ).reduce((a, b) => a + b, 0);
                            return total === 0
                              ? "0"
                              : ((value / total) * 100).toFixed(2);
                          })(),
                        }))
                        .sort((a, b) => b.percent - a.percent)}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={120}
                      fill="#8884d8"
                      label={false}
                    >
                      {Object.entries(
                        advertisementData[selectedClinic][selectedMonth][
                          selectedItem
                        ]
                      ).map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            [
                              "red",
                              "blue",
                              "green",
                              "purple",
                              "orange",
                              "pink",
                              "brown",
                              "gray",
                              "cyan",
                            ][index % 9]
                          }
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend
                      layout="vertical"
                      align="right"
                      verticalAlign="middle"
                      wrapperStyle={{ width: "35%" }}
                      formatter={(value, entry, index) => {
                        const { payload } = entry;
                        return (
                          <span
                            style={{
                              display: "inline-block",
                              wordBreak: "break-word",
                            }}
                          >
                            {`${payload.name}: ${payload.value} (${payload.percent}%)`}
                          </span>
                        );
                      }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Flex>
            </View>
            <View
              style={{
                flex: 1,
                position: "relative",
                width: "100%",
                height: "300px",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  width={500}
                  height={300}
                  data={advertisementData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar
                    dataKey={selectedDataKey}
                    fill="#8884d8"
                    activeBar={<Rectangle fill="pink" stroke="blue" />}
                  />
                </BarChart>
              </ResponsiveContainer>
            </View>
          </View>
          <View style={{ flex: 1 }}>
            <View style={{ flex: 1, overflowY: "auto" }}>
              <Heading
                level={4}
                style={{ backgroundColor: "yellow", color: "red" }}
              >
                分項數據
              </Heading>
              <View
                style={{
                  top: "50px",
                  // width: "20vw",
                }}
              >
                <SelectField
                  label="選擇數據類型"
                  value={selectedDataKey}
                  onChange={(e) => setSelectedDataKey(e.target.value)}
                >
                  {dataKeyOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </SelectField>
              </View>
              <View
                style={{
                  flex: 1,
                  position: "relative",
                  width: "100%",
                  height: "300px",
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar
                      dataKey={selectedDataKey}
                      fill="#8884d8"
                      activeBar={<Rectangle fill="pink" stroke="blue" />}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </View>
            </View>
          </View>
        </View>
      </Flex>
    );
  }

  return null; // 添加默認返回值
}
// 處理廣告數據的函數
function processADData(sample) {
  console.log("start processADData");
  const clinicMap = {};

  // 創建通用的 referral 計數對象
  const createReferralCount = () => ({
    之前看過李醫師: 0,
    親友介紹: 0,
    Google搜尋: 0,
    李醫師FB粉專: 0,
    李醫師IG粉專: 0,
    診所粉專: 0,
    本診所其他醫師轉介: 0,
    診所簡訊通知: 0,
    "本診所文宣(如影片、小卡等)": 0,
    其他: 0,
  });

  // 創建通用的月份數據結構
  const createMonthData = () => ({
    arrived: createReferralCount(),
    first: createReferralCount(),
    firstDoctorInfo: createReferralCount(),
    notFirst: createReferralCount(),
    notFirstDoctorInfo: createReferralCount(),
    doctorInfo: createReferralCount(),
    boneAge: createReferralCount(),
    daflon: createReferralCount(),
    daflon4W: createReferralCount(),
    leuplin12W: createReferralCount(),
    growthHormone: createReferralCount(),
    omnitrop: createReferralCount(),
    bloodTest: createReferralCount(),
    ultrasoundForPelvis: createReferralCount(),
  });

  sample.forEach((person) => {
    let referral = person.referral ? person.referral : "其他";
    if (person.data) {
      Object.entries(person.data).forEach(([date, appointment]) => {
        const monthYear = date.substring(0, 7); // 獲取年月，格式為 "YYYY-MM"
        const dayOfWeek = config.daysOfWeek[new Date(date).getDay()];
        const isYoyo = openTime.yoyo[dayOfWeek].length > 0;
        const clinic = isYoyo ? "yoyo" : "hansheng";

        if (!clinicMap[clinic]) {
          clinicMap[clinic] = {};
        }

        if (!clinicMap[clinic][monthYear]) {
          clinicMap[clinic][monthYear] = createMonthData();
        }

        // 先處理 first 和 notFirst
        if (appointment.first) {
          clinicMap[clinic][monthYear]["first"][referral] += 1;

          clinicMap[clinic][monthYear]["firstDoctorInfo"][referral] +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        } else {
          clinicMap[clinic][monthYear]["notFirst"][referral] += 1;
          console.log(appointment);
          clinicMap[clinic][monthYear]["notFirstDoctorInfo"][referral] +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        }

        // 再處理其他項目
        Object.keys(appointment).forEach((key) => {
          if (
            appointment[key] === true &&
            key !== "first" &&
            key !== "notFirst"
          ) {
            clinicMap[clinic][monthYear][key][referral] += 1;
          }
        });
      });
    }
  });

  return clinicMap;
}

// 處理sample數據的函數
function processSampleData(sample) {
  console.log("start processSampleData");
  const clinicMap = {};

  // 創建通用的血液檢查類型計數對象
  const createBloodTestTypeCount = () => ({
    PPG: 0,
    PPB1: 0,
    PPB: 0,
    SHOR1: 0,
    SHOR2G: 0,
    SHOR2B: 0,
    OBES1: 0,
    OBES2: 0,
    OBES3: 0,
    GH1: 0,
    GH2: 0,
    GH3: 0,
    PROL: 0,
    THY1: 0,
    THY2: 0,
  });

  // 創建通用的日期數據結構
  const createDayData = (date) => ({
    date: date,
    arrived: 0,
    notArrived: 0,
    first: 0,
    notFirst: 0,
    firstDoctorInfo: 0,
    notFirstDoctorInfo: 0,
    boneAge: 0,
    daflon: 0,
    daflon4W: 0,
    leuplin12W: 0,
    growthHormone: 0,
    omnitrop: 0,
    ultrasoundForPelvis: 0,
    bloodTest: 0,
    bloodTestType: createBloodTestTypeCount(),
  });

  // 創建通用的月份摘要數據結構
  const createMonthSummary = () => ({
    totalArrived: 0,
    totalNotArrived: 0,
    totalFirstDoctorInfo: 0,
    totalNotFirstDoctorInfo: 0,
    totalBoneAge: 0,
    totalDaflon: 0,
    totalDaflon4W: 0,
    totalLeuplin12W: 0,
    totalGrowthHormone: 0,
    totalOmnitrop: 0,
    totalBloodTest: 0,
    totalUltrasoundForPelvis: 0,
    totalFirst: 0,
    totalNotFirst: 0,
    totalBloodTestType: createBloodTestTypeCount(),
  });

  sample.forEach((person) => {
    if (person.data) {
      let index = 0;
      Object.entries(person.data).forEach(([date, appointment]) => {
        index++;
        const monthYear = date.substring(0, 7); // 獲取年月，格式為 "YYYY-MM"
        const dayOfWeek = config.daysOfWeek[new Date(date).getDay()];
        const isYoyo = openTime.yoyo[dayOfWeek].length > 0;

        const clinic = isYoyo ? "yoyo" : "hansheng";
        if (!clinicMap[clinic]) {
          clinicMap[clinic] = {};
        }
        // 如果該診所在該月份還沒有數據，則初始化數據結構
        if (!clinicMap[clinic][monthYear]) {
          clinicMap[clinic][monthYear] = {
            data: [],
            summary: createMonthSummary(),
          };
        }
        let data = clinicMap[clinic][monthYear].data;
        let summary = clinicMap[clinic][monthYear].summary;

        // 如果該日期還沒有數據，則初始化數據結構
        let dayData = data.find((item) => item.date === date);
        if (!dayData) {
          dayData = createDayData(date);
          data.push(dayData);
        }

        const isArrived = appointment.arrived ? 1 : 0;
        dayData.arrived += isArrived;
        dayData.notArrived += appointment.arrived ? 0 : 1;
        dayData.boneAge += appointment.boneAge ? 1 : 0;
        dayData.daflon += appointment.daflon ? 1 : 0;
        dayData.daflon4W += appointment.daflon4W ? 1 : 0;
        dayData.leuplin12W += appointment.leuplin12W ? 1 : 0;
        dayData.growthHormone += appointment.growthHormone
          ? parseInt(appointment.growthHormoneNumber, 10)
          : 0;
        dayData.omnitrop += appointment.omnitrop
          ? parseInt(appointment.omnitropNumber, 10)
          : 0;
        if (appointment.bloodTest) {
          dayData.bloodTest += 1;
          dayData.bloodTestType[appointment.bloodTestType] += 1;
        }

        dayData.ultrasoundForPelvis += appointment.ultrasoundForPelvis ? 1 : 0;
        if (appointment.first) {
          dayData.first += 1;
          dayData.firstDoctorInfo +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        } else {
          dayData.notFirst += 1;
          console.log(appointment);
          dayData.notFirstDoctorInfo +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        }
        summary.totalArrived += isArrived;
        summary.totalNotArrived += appointment.arrived ? 0 : 1;

        summary.totalBoneAge += appointment.boneAge ? 1 : 0;
        summary.totalDaflon += appointment.daflon ? 1 : 0;
        summary.totalDaflon4W += appointment.daflon4W ? 1 : 0;
        summary.totalLeuplin12W += appointment.leuplin12W ? 1 : 0;
        summary.totalGrowthHormone += appointment.growthHormone
          ? parseInt(appointment.growthHormoneNumber, 10)
          : 0;
        summary.totalOmnitrop += appointment.omnitrop
          ? parseInt(appointment.omnitropNumber, 10)
          : 0;
        if (appointment.bloodTest) {
          let type = appointment.bloodTestType;
          let total = summary.totalBloodTestType;
          total[type] += 1;
          summary.totalBloodTest += 1;
        }
        summary.totalUltrasoundForPelvis += appointment.ultrasoundForPelvis
          ? 1
          : 0;
        if (appointment.first) {
          summary.totalFirst += 1;
          summary.totalFirstDoctorInfo +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        } else {
          summary.totalNotFirst += 1;
          summary.totalNotFirstDoctorInfo +=
            appointment.arrived && appointment.doctorInfo ? 1 : 0;
        }
      });
    }
  });

  // 对每个诊所的数据进行排序
  for (let clinic in clinicMap) {
    for (let month in clinicMap[clinic]) {
      // 按日期从小到大排序
      clinicMap[clinic][month].data.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
    }
  }

  // console.log("clinicMap", clinicMap);
  return clinicMap;
}

export default Report;
